import React from 'react'
import { createBrowserRouter, Navigate, type RouteObject } from 'react-router-dom'
import { genRoutes, searchPath } from './route_utils'
import { menuList } from './menuLIst.config'
import App from '@/App'

const otherRoutes = genRoutes(menuList)

const indexRoute = menuList.find((item) => item.index)

if (indexRoute == null) {
  throw new Error('未配置index路由')
}

const homePath = searchPath(indexRoute.id)

if (homePath == null) {
  throw new Error('首页配置错误，无法找到首页路径，请检查menuList.config.ts文件')
}

const routes: RouteObject[] = [
  {
    element: <App />,
    children: [
      {
        id: 'root',
        path: '/',
        index: true,
        element: <Navigate to={homePath} replace />
      },
      ...otherRoutes
    ]
  }
]

const router = createBrowserRouter(routes, {
  basename: BASE_PATH === '' ? undefined : BASE_PATH
})

export default router
